module.exports = __webpack_public_path__ + "static/media/Philosopher-Regular.181af485.svg";